import { LessonLocation } from '../../../../types/graphql';
import { GeneratorInputType } from '../../../ChatGPTGenerator/MaiaGenerateLesson';

export const MODAL_HEIGHT = '660px';
export const MIN_MODAL_HEIGHT = '420px';
export const MODAL_WIDTH = '881px';

export type EditorPreference = 'classic' | 'new' | 'generate' | 'import';
export type EditorVersion = 'v1' | 'v2';
export type CreateLessonModalV1Response =
  | { type: 'lesson'; version: EditorVersion; name: string }
  | { type: 'slideDeck'; name: string; lessonId: string; isWaitingOnConversion: boolean }
  | { type: 'maia'; generatorType: GeneratorInputType; version: EditorVersion };

export type CreateLessonModalProps = {
  lessonLocation?: LessonLocation;
  setEditorPreference: (preference: string) => void;
  editorPreference?: EditorPreference;
  showAside?: boolean;
  hideUnderConstructionBanner?: boolean;
  createLessonModalVersion?: 'v1' | 'v2';
};
